export default "__VITE_ASSET__DBnwZFSI__"